import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import moment from 'moment';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import CustomPagination from '../../CustomPagination';
import Loader from '../../Loader/Loader';

import usersQuery from './usersQuery.graphql';
import { updateBanServiceHistoryStatus } from '../../../actions/siteadmin/updateBanServiceHistoryStatus';
import { deleteUser } from '../../../actions/siteadmin/users';
import { changeUsersFilter } from '../../../actions/siteadmin/ManageUsers/manageUsersData';
import { withQuery } from '../../../hoc/withGraphql';
import { decode } from '../../../helpers/queryEncryption';
import { censorEmail, censorPhone } from '../../../helpers/secureEmail';
import { demoRestriction, demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { dateFormat } from '../../../config';

import cs from '../../../components/commonStyle.css';
import s from './UserManagement.css';
import messages from '../../../locale/jsonMessages';

class UserManagement extends React.Component {
  static propTypes = {
    userManagement: PropTypes.array,
    editUser: PropTypes.any,
    deleteUser: PropTypes.any,
    title: PropTypes.string.isRequired,
    updateBanServiceHistoryStatus: PropTypes.any.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      currentPage: 1,
      searchList: '',
      userType: '',
      typing: false,
      typingTimeout: 0,
      isRestrict: false
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  handleChange = async (e, userId, userMail, userName) => {
    const { updateBanServiceHistoryStatus, adminMail, demoRestriction } = this.props;
    const { currentPage, searchList, userType } = this.props;
    let id = userId;
    let banStatus = e.target.value ? parseInt(e.target.value) : '';
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await updateBanServiceHistoryStatus(id, banStatus, userMail, userName, currentPage, searchList, adminMail, userType);
  }

  paginationData = (currentPage) => {
    const { userManagement: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }

  handleClick = (searchList) => {
    const { userManagement: { refetch }, setStateVariable } = this.props;
    let variables = {
      currentPage: 1,
      searchList: searchList
    };
    this.setState({ currentPage: 1 });
    setStateVariable(variables);
    refetch(variables);
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  deleteChange = async (id, profileId, userType) => {
    const { deleteUser, demoRestriction } = this.props;
    const { userManagement: { refetch, userManagement }, setStateVariable, currentPage } = this.props;
    let variables = { currentPage: 1 && userManagement?.usersData?.length == 1 ? currentPage - 1 : currentPage };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    const response = await deleteUser(id, profileId, userType);
    if (response?.status == 200) {
      await setStateVariable(variables);
      await refetch(variables);
    }
  }

  handleUserChange = async (userType) => {
    const { userManagement: { refetch }, setStateVariable, changeUsersFilter, currentPage, searchList } = this.props;
    let variables = { currentPage: 1, searchList, userType };
    changeUsersFilter(currentPage, searchList, userType)
    setStateVariable(variables);
    refetch(variables);
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.name) },
      { data: formatMessage(messages.emailLabel) },
      { data: formatMessage(messages.phoneLabel) },
      { data: formatMessage(messages.createdDate) },
      { data: formatMessage(messages.actionLabel) },
    ]
  };

  tbody = (props) => {
    const { userManagement: { userManagement } } = props;
    const { formatMessage } = this.props.intl;
    const { isRestrict } = this.state;

    return userManagement?.usersData.map(value => {
      const userMail = decode(value?.email), phoneNumber = decode(value?.profile?.phoneNumber);
      return {
        id: value?.id,
        data: [
          { data: value?.profile?.profileId },
          {
            data:
              <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
                <a href={"/siteadmin/profileView/" + ((value.profile) ? value.profile.profileId : '')}>
                  {value?.profile?.firstName}
                </a>
                <TableAction
                  onClickDelete={() => this.deleteChange(value.id)}
                  showDelete={true}
                  showView={true}
                  showEdit={true}
                  editLink={"/siteadmin/edit-profile/" + ((value.profile) ? value.profile.profileId : '')}
                  link={"/siteadmin/profileView/" + ((value.profile) ? value.profile.profileId : '')}
                /> </div>
          },
          { data: !isRestrict ? userMail : censorEmail(userMail) },
          {
            data: (value?.profile?.countryCode && value?.profile?.phoneNumber) ? '\u200E' + value?.profile?.countryCode + (!isRestrict ? phoneNumber : censorPhone(phoneNumber)) : '-'
          },
          { data: moment(parseInt(value?.profile?.createdAt)).format('L') },
          {
            data: <div>
              <select name="userBanStatus" className='commonTableInsideSelect'
                onChange={(e) => this.handleChange(e, value.id, userMail, value?.profile?.firstName)} value={value.userBanStatus ? '1' : '0'}>
                <option value="">{formatMessage(messages.selectLabel)}</option>
                <option value="1">{formatMessage(messages.banLabel)}</option>
                <option value="0">{formatMessage(messages.unBanLabel)}</option>
              </select></div>
          },
        ]
      }
    })
  }
  userTypeFilter = () => {
    const { formatMessage } = this.props.intl;
    return [
      { value: "", label: formatMessage(messages.all) },
      { value: "1", label: formatMessage(messages.guest) },
      { value: "2", label: formatMessage(messages.host) }
    ]
  }

  render() {
    const { userManagement: { loading, userManagement } } = this.props;
    const { currentPage, searchList, userType } = this.props;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <Loader type={"text"} />
    }

    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.manageUser)}
          isExport
          exportLink={`/export-admin-data?type=users&userType=${userType}&search=${searchList}`}
          isSearch
          onSearch={this.handleSearchChange}
          userTypeFilter={this.userTypeFilter()}
          handleUserChange={this.handleUserChange}
        />
        {
          !loading && userManagement?.usersData?.length > 0
          && <div>
            <CustomPagination
              total={userManagement.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.usersLabel)}
            />
          </div>
        }
      </div>
    );
  }
}
const mapState = (state) => ({
  adminMail: state.siteSettings.data.email
});
const mapDispatch = {
  updateBanServiceHistoryStatus,
  deleteUser,
  changeUsersFilter,
  demoRestriction,
  demoRestrictionEncode
};
export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(usersQuery, {
    name: 'userManagement',
    options: (props) => ({
      variables: {
        currentPage: 1,
        searchList: '',
        userType: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(UserManagement);
